module.exports = __webpack_public_path__ + "img/book2.6bf8fa0f.jpg";